
import { Component, Vue } from 'vue-property-decorator'
import { BugService } from '@/services/index'
import BugTable from './components/bugTable.vue'

@Component({
    name: 'BugList',
    components: {
        BugTable
    }
})
export default class extends Vue {
    private bugTypeMap: any = {
        all: 0,             // 全部
        nameError: 1,       // 记者名抽取错误
        noName: 2,          // 漏抽记者名
        classError: 3,      // 分类问题
        layoutError: 4,     // 文章排版问题
        tagError: 5,        // 标签抽取问题
        reprintError: 6     // 转载识别问题
    }
    private bugStatusMap: any = {
        all: 0,     // 全部
        toFix: 1,   // 待解决
        fixed: 2    // 已解决
    }
    private bugTypeOptions = [
        { key: 'all', value: '所有类型' },
        { key: 'nameError', value: '记者名抽取错误' },
        { key: 'noName', value: '漏抽记者名' },
        { key: 'classError', value: '分类问题' },
        { key: 'layoutError', value: '文章排版问题' },
        { key: 'tagError', value: '标签抽取问题' },
        { key: 'reprintError', value: '转载识别问题' }
    ]
    private tabOptions = [
        { key: 'toFix', value: '待解决' },
        { key: 'fixed', value: '已解决' },
        { key: 'all', value: '全部' }
    ]
    private bugTimeOptions = [
        { key: 'created_at', value: 'Bug提出时间' },
        { key: 'updated_at', value: 'Bug更新时间' }
    ]
    private bugTimeOption = 'created_at'
    private bugTypeOption = 'all'
    private tabOption = 'toFix'
    private bugList: any = []
    private bugDealPercent: string = ''
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = false

    private mounted() {
        this.getBugList()
    }

    private async getBugList() {
        const params = {
            // 根据选中的bug类型选项获取对应的类型值(问题类型)
            type: this.bugTypeMap[this.bugTypeOption],
            // 根据选中的tab选项获取对应的状态值(解决状态)
            status: this.bugStatusMap[this.tabOption],
            // 排序方式（按创建时间或更新时间）
            sort: this.bugTimeOption,
            // 当前页码
            page_index: this.pageIndex,
            // 每页显示的条数
            page_size: this.pageSize
        }
        // 获取bug列表数据
        const result = await BugService.getList(params)
        if (result.status === 200) {
            this.bugList = result.data.bug_list
            this.pageTotal = result.data.page_total
            this.bugDealPercent = result.data.deal_percent * 100 + '%'
        }
    }

    private updateBug(bug: any) {
        if (bug) {
            const index = this.bugList.findIndex((item: any) => item.id === bug.id)
            if (this.tabOption === 'all') {
                this.bugList[index] = bug
            } else {
                this.bugList.splice(index, 1)
            }
        } else {
            this.getBugList()
        }
    }

    private onBugTypeChange() {
        this.pageIndex = 1
        this.getBugList()
    }

    private onBugTimeChange() {
        this.pageIndex = 1
        this.getBugList()
    }

    private onTabClick() {
        this.pageIndex = 1
        this.getBugList()
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getBugList()
        $backtop.scrollToTop()
    }
}
